import { Badge, Breadcrumb, Button, Flex, Text, VStack } from "@chakra-ui/react"
import { Link } from "@tanstack/react-router"
import { FiEdit2, FiUpload } from "react-icons/fi"

import type { QuizPublishStatusMeta } from "@/utils/quiz-status"
import type { QuizBuilderMode } from "./quiz-builder-types"

export interface QuizBuilderHeaderProps {
  mode: QuizBuilderMode
  onSave: () => void
  isSaving: boolean
  onBatchUpload?: () => void
  publishStatus?: QuizPublishStatusMeta
}

export function QuizBuilderHeader({
  mode,
  onSave,
  isSaving,
  onBatchUpload,
  publishStatus,
}: QuizBuilderHeaderProps) {
  return (
    <VStack align="stretch" mb={6} gap={4}>
      {/* Breadcrumbs */}
      <Breadcrumb.Root>
        <Breadcrumb.List>
          <Breadcrumb.Item>
            <Breadcrumb.Link asChild>
              <Link to="/quiz-management">Quiz Management</Link>
            </Breadcrumb.Link>
          </Breadcrumb.Item>
          <Breadcrumb.Separator />
          <Breadcrumb.Item>
            <Breadcrumb.CurrentLink>
              {mode === "edit" ? "Edit Quiz" : "Add Quiz"}
            </Breadcrumb.CurrentLink>
          </Breadcrumb.Item>
        </Breadcrumb.List>
      </Breadcrumb.Root>

      {publishStatus && (
        <Flex align="center" justify="space-between" wrap="wrap" gap={3}>
          <Badge colorPalette={publishStatus.color} size="lg" px={3} py={1}>
            {publishStatus.label}
          </Badge>
          <Text color="gray.600" fontSize="sm">
            {publishStatus.description}
          </Text>
        </Flex>
      )}

      {/* Action buttons */}
      <Flex justify="flex-end" align="center" wrap="wrap" gap={3}>
        {onBatchUpload && (
          <Button variant="outline" onClick={onBatchUpload} gap={2}>
            <FiUpload />
            Batch Upload
          </Button>
        )}
        <Button colorPalette="blue" onClick={onSave} loading={isSaving} gap={2}>
          {mode === "edit" && <FiEdit2 />}
          {mode === "edit" ? "Update Quiz" : "Save Quiz"}
        </Button>
      </Flex>
    </VStack>
  )
}
